/*=========================================================================================
  File Name: moduleCustomerGetters.js
  Description: Customer Module Getters
==========================================================================================*/

export default {
	queriedCustomers: state =>
		state.customers.filter(customer => {
			let isItemOfCurrentFilter = false;

			if ((state.customersFilter === "all" && !customer.isTrashed) || (state.customersFilter === "trashed" && customer.isTrashed)) {
				isItemOfCurrentFilter = true;
			}

			return isItemOfCurrentFilter && customer.desc.toLowerCase().includes(state.customersSearchQuery.toLowerCase());
		}),
	getCustomer: state => customerId => state.customers.find(customer => customer.id === customerId),
	getParsedCustomers: state =>
		state.customers.map(customer => ({
			...customer
		}))
};
